import { useSnackbarContext } from 'Context/SnackbarContext';
import React, { useState } from 'react';
import { FDSecondaryActionButton } from '@facet-wealth/design';
import { DataValueMap } from 'Helpers/Testing';
import knownFacetDesignIconTypes from 'Icons/mapping/knownFacetDesignIconTypes';
import PropTypes from 'prop-types';
import Relationship from 'facet-rest/src/domain/Relationship';

export default function ActionItemButton({
  relationship, onClick, dataTestValue, disabled,
}) {
  const { displayErrorMessage } = useSnackbarContext();
  const [loading, setLoading] = useState(false);

  const handleOnClick = async () => {
    try {
      setLoading(true);
      await onClick(relationship);
    } catch (err) {
      displayErrorMessage('Failed to submit current action item');
    }
    setLoading(false);
  };

  return (<FDSecondaryActionButton
    {...DataValueMap.init(dataTestValue).build()}
    icon={knownFacetDesignIconTypes[relationship.meta('icon')]}
    label={relationship.meta('prompt')}
    loading={loading}
    size={'sm'}
    disabled={disabled}
    onClick={() => handleOnClick(relationship)}
  />);
}

ActionItemButton.propTypes = {
  relationship: PropTypes.instanceOf(Relationship).isRequired,
  onClick: PropTypes.func.isRequired,
  dataTestValue: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
};
